import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import { Helmet } from "react-helmet";
import { ExperienceData } from "../components/experienceData/experienceData";
import { HashLink } from "react-router-hash-link";
import {
  CarouselServices,
  CarouselStories,
} from "../components/carouselHome/carouselHome";
import { Clients } from "../components/clients/clients";

import ImgWhy from "../assets/imgs/bg_why_jci.png";

import promoVdo from "../assets/video/demoJCinnovation.mp4";
import { useTranslation } from "react-i18next";

export const HomePage = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    scrollToTop();
  });
  const { t } = useTranslation();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Helmet>
        <title>JC Innovation</title>
      </Helmet>
      <section className="wrapper_home_page">
        <div className="wrapper_home">
          <div className="container-lg">
            <div className="sec_content_home">
              <div className="content_info">
                <div className="box_info_home">
                  <h1 className="ttls ttl_in_home">
                    <span className="fw_700">
                      {t("Creamos experiencias memorables")}
                    </span>{" "}
                    {t(
                      "a través de eventos en vivo, híbridos y herramientas digitales personalizadas"
                    )}
                  </h1>
                  <div className="text-center">
                    {/* <a href="#aliados" className="btn btn-primary mt-3">
                      {t("Conoce nuestros servicios")}{" "}
                    </a>{" "} */}
                    <HashLink
                      className="btn btn-primary mt-3"
                      smooth
                      to="/#servicios"
                      scroll={(el) => {
                        setTimeout(() => {
                          el.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                          });
                        }, 50); // 100ms para dar chance al render
                      }}
                    >
                      {t("Conoce nuestros servicios")}
                    </HashLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ExperienceData />
        </div>

        <div className="wrapper_services_home" id="servicios">
          <div className="container-lg">
            <h2 className="ttls ttl_section c_marin mb-4 text-center">
              {t("Nuestros servicios")}
            </h2>
            <CarouselServices />
          </div>
        </div>

        <div className="wrapper_clients" id="aliados">
          <div className="container-lg">
            <div className="content_clients">
              <h2 className="ttls ttl_section c_marin mb-4 text-center">
                {t("Aliados y amigos")}
              </h2>
              <Clients />
            </div>
          </div>
        </div>

        <div className="wrapper_success_stories">
          <div className="container-lg">
            <h2 className="ttls ttl_section c_marin mb-4 text-center">
              {t("Casos de Éxito")}
            </h2>
            <CarouselStories />
          </div>
        </div>

        <div className="wrapper_why_jci">
          <div className="container-lg">
            <h2 className="ttls ttl_section mb-4 text-center">
              {t("¿Por qué elegir JC-Innovation?")}
            </h2>
            <p style={{ fontSize: "1.25rem", textAlign: "center" }}>
              {t(
                "Creamos congresos eventos desde cero, hospedaje, locación, diseño, producción visual, plataformas digitales, redes sociales, fotografía, streaming con un equipo experto"
              )}
            </p>
            <div className="info_why_jci">
              <div className="bg_video_why">
                <button
                  className="popup-video mfp-iframe"
                  data-bs-toggle="modal"
                  data-bs-target="#videoModal"
                  onClick={toggle}
                >
                  <img
                    className="trans"
                    src={ImgWhy}
                    alt="¿Por qué elegir JC-Innovation?"
                  />
                </button>
              </div>
              <div className="why_info">
                <div className="item_why_info">
                  <h3>{t("Calidad")}</h3>
                  <p>
                    {t(
                      "La satisfacción de nuestros clientes es importante, por esomantenemos una estandarización para que todos nuestros productos y servicios sean únicos"
                    )}
                    .
                  </p>
                </div>
                <div className="item_why_info">
                  <h3>{t("Productividad")} </h3>
                  <p>
                    {t(
                      "Trabajamos con pasión y disfrutamos las responsabilidades que nos evocan, siempre en tiempo y forma"
                    )}
                    .
                  </p>
                </div>
                <div className="item_why_info">
                  <h3>{t("Innovación")} </h3>
                  <p>
                    {t(
                      "Exigimos lo mejor, gracias a un gran equipo de expertos creativos que día a día se mantienen a la vanguardia"
                    )}
                    .
                  </p>
                </div>
                <div className="item_why_info">
                  <h3>{t("Comunicación")}</h3>
                  <p>
                    {t(
                      "Nos apegamos a los valores y principios que rigen a nuestros clientes, siempre de una amigable y respetuosa"
                    )}
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <Modal
          isOpen={modal}
          toggle={toggle}
          centered
          className="wrapper_modal_home"
        >
          <div className="sec_video_pride">
            <span className="btnclose" onClick={toggle}>
              <i className="fa-solid fa-xmark"></i>
            </span>
            <video controls preload autoPlay>
              <source src={promoVdo} type="video/mp4" />
            </video>
          </div>
        </Modal>
      </section>
    </>
  );
};
